/** "Big online travel agencies have the slowest flight search, even with fast sister sites": metadata (the article is in ../bodies/biggest-travel-sites-slowest-flight-search.js). */
export default {
  slug: 'biggest-travel-sites-slowest-flight-search',
  category: 'Research',
  label: 'Research · November 2026',
  title: 'Big online travel agencies have the slowest flight search, even with fast sister sites',
  seoTitle: 'Slowest Flight Search Sites: OTAs vs Metasearch',
  description: 'Big online travel agencies took 7 to 17 seconds to show flights in our speed test, metasearch sites under 3, and often the same company owns both.',
  dek: 'We regrouped our October 2026 flight search speed test by type of site and by owner. The agencies where you book and pay were the slowest, and two of the companies that own them also run some of the fastest search sites.',
  author: 'Stephanie Ludwig',
  published: '2026-11-03',
  updated: '2026-11-03',
  faqs: [
    {
      q: 'Which flight search sites are the slowest?',
      a: 'In our October 2026 test, Priceline was the slowest at 16.65 seconds on average to show its first priced flights, followed by CheapOair at 15.06 seconds, Booking.com at 13.34 seconds and Trip.com at 12.35 seconds. All four are online travel agencies.',
    },
    {
      q: 'What is the fastest flight search engine?',
      a: 'Google Flights, at 0.82 seconds on average in our October 2026 test. Every metasearch engine we tested, including Kayak, Cheapflights, Momondo and Skyscanner, showed its first results in under 3 seconds.',
    },
    {
      q: 'Are Kayak and Booking.com owned by the same company?',
      a: 'Yes. Booking Holdings owns Booking.com, Priceline and Kayak, and Cheapflights and Momondo are managed by Kayak. In our test the Kayak-run sites averaged 2.51 to 2.72 seconds, while Booking.com and Priceline averaged 13.34 and 16.65 seconds.',
    },
    {
      q: 'Who owns Skyscanner?',
      a: 'Trip.com Group, which lists Skyscanner among its brands and has included it in its consolidated results since December 2016. Skyscanner averaged 2.75 seconds in our test, and its sister site Trip.com averaged 12.35 seconds.',
    },
    {
      q: 'What is the difference between metasearch and an online travel agency?',
      a: 'A metasearch engine compares prices from airlines and agencies and sends you to one of them to book and pay. An online travel agency sells the flight itself, so you book and pay on its own site.',
    },
    {
      q: 'Does a faster flight search site have cheaper flights?',
      a: 'Not necessarily. Our test measured only how quickly the first priced flights appeared, not which site had the lowest fare, so compare prices on more than one site before you book.',
    },
  ],
  related: [
    'fastest-flight-search-engines',
    'do-cheap-flight-sites-have-cheaper-fares',
    'cheapest-day-to-fly',
  ],
};
